import Vec2D from './Vec2d';
import { Vector2, Vector3 } from 'three';
import * as THREE from 'three';

export class Ship {
	constructor(x, y, shipModel, maxShipHealth) {
		//this.ref = ref;
		this.angle = 0;
		this.speed = 0;

		this.pos = new Vector3(x, y, 0);
		this.vel = new Vector3(0, 0, 0);
		this.thrust = new Vector3(0, 0, 0);

		this.idle = false;
		this.radius = 8;
		this.idleDelay = 0;
		this.sprite = new Image();
		this.bulletDelay = 0;
		this.maxShipHealth = maxShipHealth;
		this.health = this.maxShipHealth;
		this.shootSound = new Audio('/assets/sounds/laser_2.mp3');

		this.mesh = shipModel; //new THREE.Mesh(geometry, material);
		this.mesh.scale.set(0.47, 0.47, 0.47);

		this.astBox;

		//Thrusters generate particle pool
		this.movementSpeed = 0.05;
		this.thrusterSpread = 0.04;
		this.particleLife = 120;
		this.dirs = [];
		this.particlesNumber = 160;
		this.geometry = new THREE.BufferGeometry();
		const arr = new Float32Array(this.particlesNumber * 3);
		this.lifeSpanArr = [];
		this.fromColor = new THREE.Color(0xff0000);

		for (let i = 0; i < this.particlesNumber; i++) {
			let pos = i * 3;

			arr[pos] = 0;
			arr[pos + 1] = 0;
			arr[pos + 2] = 0;

			//p.pos.setXY(this.ship.pos.getX() + Math.cos(this.ship.angle) * -14, this.ship.pos.getY() + Math.sin(this.ship.angle) * -14);

			this.dirs.push({
				x: 0,
				y: 0,
				z: 0,
			});

			this.lifeSpanArr.push(Math.random() * this.particleLife);
		}

		this.geometry.setAttribute('position', new THREE.BufferAttribute(arr, 3));

		this.material = new THREE.PointsMaterial({
			size: 0.15,
			blending: THREE.AdditiveBlending,
			transparent: true,
			depthTest: false,
			color: 0x852250,
			//map: new THREE.TextureLoader().load('/assets/thrust_particle.png'),
		});

		this.particles = new THREE.Points(this.geometry, this.material);

		return this;
	}

	update() {
		//ships position
		++this.bulletDelay;

		if (this.idle) {
			if (++this.idleDelay > 120) {
			}
		} else {
			this.updateThruster();
			this.pos.add(this.vel);

			this.mesh.updateMatrix();
			this.mesh.updateMatrixWorld();
		}
	}

	updateThruster() {
		let positions = this.particles.geometry.attributes.position.array;

		for (let i = 0; i < this.particlesNumber; i++) {
			let pos = i * 3;

			positions[pos] += this.dirs[i].x;
			positions[pos + 2] += this.dirs[i].z;

			this.lifeSpanArr[i] -= 1;

			//this.particles[pos].material.opacity -= 0.01;

			//this.colorTrans += 0.0001;
			//this.material.color.copy(this.fromColor).lerpHSL(this.toColor, this.colorTrans);

			if (this.lifeSpanArr[i] <= 0) {
				positions[pos] = this.pos.x + Math.cos(this.angle - 1.6) * 1.2;
				positions[pos + 2] = this.pos.z + Math.sin(this.angle - 1.6) * -1.2;

				let ms = this.movementSpeed + this.speed / 5;
				//Set particle to posituon 0
				this.dirs[i].x = Math.cos(this.angle - 1.6) * ms + (Math.random() * this.thrusterSpread - this.thrusterSpread / 2);
				//positions[pos + 1] = 100;
				this.dirs[i].z = Math.sin(this.angle - 1.6) * -1 * ms + (Math.random() * this.thrusterSpread - this.thrusterSpread / 2);
				//this.material.opacity = 1;
				this.lifeSpanArr[i] = this.particleLife;
			}
		}

		this.particles.geometry.attributes.position.needsUpdate = true;
	}

	shoot(callback) {
		if (this.bulletDelay > 6) {
			//this.shootSound.cloneNode(true).play();

			callback();
			this.bulletDelay = 0;
		}
	}

	reset() {
		this.idle = false;
		this.health = this.maxShipHealth;
		this.pos = new Vector3(0, 0, 0);
		this.vel = new Vector3(0, 0, 0);
	}
}
